import React from 'react'
import {Notifications} from "../components";

export const NotificationsPage: React.FC = () => <Notifications/>;
